import React from 'react';
import { useTexts } from '../data';

const ConfirmModal = ({ isOpen, onConfirm, onCancel }) => {
  const TEXTS = useTexts();

  if (!isOpen) return null;

  return (
    <div
      className="modal show d-block"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{TEXTS.CONFIRM_SUBMIT_TITLE}</h5>
          </div>
          <div className="modal-body">
            <p>{TEXTS.CONFIRM_SUBMIT_MESSAGE}</p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCancel}
            >
              {TEXTS.CONFIRM_NO}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={onConfirm}
            >
              {TEXTS.CONFIRM_YES}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
